<template>
  <div class="sunshine-port">
    <Crumbs :info='info' :title='navList[0]'/>
    <div class="port-container">
      <div class="port-nav">
        <menu-com :navList='navList'></menu-com>
      </div>
      <div class="port-content">
        <h2>阳光通关</h2>
        <p>阳光跨境平台提供线上通关服务，为出口跨境电商企业、物流企业等出口申报主体企业提供订单、收款单、运单、清单、汇总申请单、撤销单等数据申报服务，并在各主体申报过程中对接上下游企业进行申报信息互相推送，数据共享功能，缩短企业间线下沟通时效，提升通关效率。并且针对不同的企业情况，提供有标准接口对接与excel表格导入两种方式对接申报</p>
        <p>出口线上通关服务支持实现无纸化通关，简化通关流程，提高通关效率，降低通关成本。通关系统7*24全天候线上作业，处理能力可达到2,000,000单/天。</p>
        <div>
           <img src="../../../assets/images/sunShine/lc.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import menuCom from "./common/menuCom.vue"
import Crumbs from "./common/Crumbs.vue"
import {navList} from "../../../model/sunShine"
export default {
  components:{
    menuCom,Crumbs
  },
  data () {
    return {
      info:{},
      navList,
    }
  },
  created(){
    const path=this.$route.fullPath;
    const index=navList.findIndex(item=>item.path===path);
    if(index!==-1){
      this.info=navList[index];
    }
  }
};
</script>

<style scoped>
.port-container {
  width: 1200px;
  height: 920px;
  margin: 0 auto;
  display: flex;
  padding: 34px 30px;
  border: 1px solid #d3d3d3;
  margin-top: 30px;
  margin-bottom: 186px;
}
.port-content {
  flex:1;
}
.port-content h2 {
  height: 38px;
  font-size: 30px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: center;
  color: #34373b;
  line-height: 38px;
  display: block;
  margin-bottom: 34px;
}
.port-content p {
  text-indent: 2em;
  font-size: 18px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #000000;
  line-height: 34px;
  margin-bottom: 34px;
}
</style>



// WEBPACK FOOTER //
// src/components/children/SunShine/Port.vue